/* KLAAR — homepage safety + mobile sticky behavior. Work theme only. */
(function () {
  var root = document.documentElement;
  var hero;
  var finalCta;
  var OLD_PRODUCT_PATH = '/products/protege-canape-premium-modulaire-resistant-a-l-eau';
  var NEW_PRODUCT_PATH = '/products/protege-canape-matelasse-klaar';

  function fixHomepageLinks() {
    document.querySelectorAll('a[href]').forEach(function (link) {
      var href = link.getAttribute('href') || '';
      if (href === OLD_PRODUCT_PATH || href.indexOf(OLD_PRODUCT_PATH + '?') === 0 || href.indexOf(OLD_PRODUCT_PATH + '#') === 0) {
        link.setAttribute('href', href.replace(OLD_PRODUCT_PATH, NEW_PRODUCT_PATH));
      }
    });
  }

  function removeUnverifiedWaterClaims() {
    var heroCopy = document.querySelector('.k4-hero-copy .k4-copy');
    if (heroCopy) {
      heroCopy.textContent = 'Une protection matelassée pour préserver les zones les plus exposées aux poils, petites traces et salissures du quotidien — sans cacher tout votre canapé.';
    }

    document.querySelectorAll('.k4-fact').forEach(function (fact) {
      var label = fact.querySelector('span');
      var value = fact.querySelector('strong');
      if (label && value && label.textContent.trim() === 'Usage') {
        value.textContent = 'Maison & animaux';
      }
    });

    var sceneCopy = document.querySelector('.k4-scene-copy .k4-copy');
    if (sceneCopy) {
      sceneCopy.textContent = 'Poils, petites salissures et traces du quotidien : KLAAR ajoute une couche de protection là où elle est utile, avec un relief matelassé qui reste visuellement textile.';
    }

    var truth = document.querySelector('.k4-truth-copy');
    if (truth) {
      var kicker = truth.querySelector('.k4-k');
      var heading = truth.querySelector('.k4-h2');
      var copy = truth.querySelector('.k4-copy');
      var note = truth.querySelector('.k4-note');
      if (kicker) kicker.textContent = '06 / Protection ciblée';
      if (heading) heading.textContent = 'Préserver la zone qui compte.';
      if (copy) copy.textContent = 'KLAAR couvre la partie du canapé que vous souhaitez préserver des poils, petites salissures et traces du quotidien, sans envelopper tout le mobilier.';
      if (note) note.innerHTML = '<strong>Conseil :</strong> mesurez directement la zone à protéger avant de choisir votre format.';
    }

    document.querySelectorAll('.k4-faq details').forEach(function (detail) {
      var summary = detail.querySelector('summary');
      var paragraph = detail.querySelector('p');
      if (summary && summary.textContent.trim() === 'Est-ce totalement étanche ?') {
        summary.textContent = 'Que protège KLAAR au quotidien ?';
        if (paragraph) paragraph.textContent = 'KLAAR aide à préserver les zones exposées aux poils, petites traces et salissures du quotidien.';
      }
    });
  }

  function applyHomepageSafety() {
    fixHomepageLinks();
    removeUnverifiedWaterClaims();
  }

  function syncStickyGate() {
    if (window.innerWidth > 900 || root.classList.contains('shopify-design-mode')) {
      root.classList.remove('klaar-sticky-eligible');
      return;
    }

    hero = hero || document.querySelector('.k4-hero');
    finalCta = finalCta || document.querySelector('.k4-final');

    if (!hero) {
      root.classList.remove('klaar-sticky-eligible');
      return;
    }

    var y = window.scrollY || 0;
    var eligible = y > Math.max(360, hero.offsetHeight * 0.92);

    if (finalCta) {
      var finalRect = finalCta.getBoundingClientRect();
      if (finalRect.top < window.innerHeight * 0.88) eligible = false;
    }

    root.classList.toggle('klaar-sticky-eligible', eligible);
  }

  function initKlaarHomepage() {
    applyHomepageSafety();
    syncStickyGate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initKlaarHomepage, { once: true });
  } else {
    initKlaarHomepage();
  }

  window.addEventListener('scroll', syncStickyGate, { passive: true });
  window.addEventListener('resize', syncStickyGate);
  document.addEventListener('shopify:section:load', function () {
    applyHomepageSafety();
    syncStickyGate();
  });
})();
